export default "__VITE_ASSET__CTcis3e1__"